export default "//file.bilionpass.com/japandx-portal/0.1.15/static/img/orbit-01.200770bf-6dd272.svg";